import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";

import {
  getFallbackLanguages,
  resolveDetectedLanguage,
  SUPPORTED_LANGUAGE_CODES,
  USER_LANGUAGE_STORAGE_KEY,
} from "./languageConfig";
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(new ICU())
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: (languages: string | readonly string[], namespaces: string | readonly string[]) => {
        const language = Array.isArray(languages) ? languages[0] : languages;
        const namespace = Array.isArray(namespaces) ? namespaces[0] : namespaces;

        return `/locales/${language}/${namespace}.json`;
      },
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupLocalStorage: USER_LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
      convertDetectedLanguage: (lng: string) =>
        resolveDetectedLanguage(lng, navigator.languages?.[0] ?? navigator.language ?? lng),
    },
    fallbackLng: (code?: string) =>
      getFallbackLanguages(code, navigator.languages?.[0] ?? navigator.language ?? code),
    debug: process.env.NODE_ENV === "development",
    i18nFormat: {
      escapeVariables: false,
    },
    interpolation: {
      escapeValue: false,
    },
    load: "currentOnly",
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
  });

export default i18n;
